import React, { useContext, useEffect, useState } from "react";
import '../css/Cards.css';
import "./carts.css";
import { CartContext } from "./ContextProvider";
import DeleteIcon from '@mui/icons-material/Delete';
import Loader from "../common/Loader";
import PayButton from "../Payment/PayButton";
import OrderSuccess from "../Payment/orderSuccess";


function CartItems(props) {

  const { orderSuccess,cartItems,setDisplayRazorpay, removeCartItem, totalPrice, updateQuantity, qtyloading } = useContext(CartContext);
  const [loading, setLoading] = useState(false);

  useEffect(()=>{
    
    setDisplayRazorpay(false)
  })





  function handleSelectChange(event, item) {
    updateQuantity(item, event.target.value);
  }

  async function handleDelete(item) {
    setLoading(true)
    await removeCartItem(item)
    setLoading(false)
  }

  return (
    <div>
      {loading ? (<Loader></Loader>) : (<div className="cartitems">
        <div className="cart-heading">
          <h1>My Cart Items</h1>
        </div>

        <div className="cartitems-format-main cartitems-header">
          <p className="product">Product</p>
          <p className="item-name ">Title</p>
          <p className="price">Price</p>
          <p className="quantity">Quantity</p>
          <p className="total">Total</p>
          <p className="remove">Remove</p>
        </div>

        <hr className="hr-after-header" />
        
        {cartItems.map(item => {
          return <div>
            <div className="cartitems-format cartitems-format-main">
              <div className="img-price">
                <img src={item.image} alt="" className="carticon-product-icon" />
              </div>


              <div className="name-price">

                <p className="item-name">{item.name}</p>

                <div className="rupees-delete">
                  <p className=''> &#8377; {Math.floor(item.price * item.quantity)}</p>
                  <select disabled={qtyloading} value={item.quantity} onChange={(event) => handleSelectChange(event, item)} className="cartitems-quantity-mob" name="qty">
                    <option value={1}>1</option>
                    <option value={2}>2</option>
                    <option value={3}>3</option>
                    <option value={4}>4</option>
                    <option value={5}>5</option>
                    <option value={6}>6</option>
                    <option value={7}>7</option>
                    <option value={8}>8</option>
                    <option value={9}>9</option>
                    <option value={10}>10</option>
                  </select>
                </div>

                <DeleteIcon className="cartitem-remove-ico delete-mob" onClick={() => handleDelete(item)} />

              </div>


              <p className='rupees priceOfProduct'> &#8377; {Math.floor(item.price)}</p>
              <select disabled={qtyloading} value={item.quantity} onChange={(event) => handleSelectChange(event, item)} className="cartitems-quantity" name="qty">
                    {[...Array(10)].map((_, index) => (
                      <option key={index} value={index + 1}>{index + 1}</option>
                    ))}
                  </select>
              <p className='rupees'> &#8377; {Math.floor(item.price * item.quantity)}</p>
              <DeleteIcon className="cartitem-remove-icon" onClick={() => handleDelete(item)} />
            </div>
            <hr />
          </div>
        })}

        <div className="cartitems-down">
          <div className="cartitems-total">
            <h1>Cart Totals</h1>
            <div>
              <div className="cartitems-total-item">
                <p>Subtotal</p>
                <p className='rupees'> &#8377; {Math.floor(totalPrice)}</p>
              </div>
              <hr />
              <div className="cartitems-total-item">
                <p>Delivery Fee</p>
                <p>Free</p>
              </div>
              <hr />
              <div className="cartitems-total-item">
                <p>Tax</p>
                <p>{Math.floor(0.05 * totalPrice)}</p>
              </div>
              <hr />
              <div className="cartitems-total-item">
                <h3>Total</h3>
                <h3 className='rupees'> &#8377; {Math.floor(totalPrice + (0.05 * totalPrice))}</h3>
              </div>
            </div>
            <PayButton className='pay-button'/>


           
          </div>
        </div>
      </div>)
      }</div>)
}

export default CartItems;
